import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          "h-11 w-full appearance-none rounded-lg border border-studio-border bg-studio-card pl-3.5 pr-9 text-base text-studio-ink outline-none transition-all focus:border-studio-accent/60 focus:shadow-glow-sm disabled:cursor-not-allowed disabled:opacity-50 sm:h-10 sm:text-sm",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-studio-faint" />
    </div>
  )
);
Select.displayName = "Select";
